/* B2Ctelecom – typekiezer fase 1: Storefront-controle op ACTIVE + beschikbaar (uitvoeringsplan 7b).
 * - Eén aanvraag per pagina: products(query: "id:… OR id:…"). De Storefront-productlijst bevat geen UNLISTED-,
 *   DRAFT- of ARCHIVED-producten (getest 21-10-2026); availableForSale geeft de beschikbaarheid.
 * - Per hoesjestype maximaal één tegel: de eerste kandidaat in rangvolgorde (1 retourexemplaar → 2 gewoon → 3 origineel)
 *   die ACTIVE én beschikbaar is.
 * - Veilig terugvallen: bij een fout of time-out (3 s) worden nooit tegels uit het <template> getoond (retourexemplaar,
 *   origineel, of in strikte modus alle alternatieven). In normale modus blijven de server-tegels staan (al gefilterd op
 *   beschikbaarheid in Liquid).
 * - Alleen voor tests in de preview: ?b2c_sim=fail (aanvraag mislukt), ?b2c_sim_unavail=<product-id,...> (gesimuleerd
 *   uitverkocht), ?b2c_sim=slow (time-out). Deze parameters werken niet in het live thema-ontwerp als ze worden weggelaten.
 */
(function () {
  'use strict';
  function run() {
  var root = document.querySelector('[data-b2c-types]:not([data-b2c-checked])');
  if (!root) return;
  root.setAttribute('data-b2c-checked', 'busy');
  var list = root.querySelector('[data-b2c-types-list]');
  var tpl = root.querySelector('template[data-b2c-types-cands]');
  var strict = root.getAttribute('data-strict') === 'true';
  var TIMEOUT_MS = 3000;
  var params = new URLSearchParams(window.location.search);
  var sim = params.get('b2c_sim') || '';
  var simUnavail = (params.get('b2c_sim_unavail') || '').split(',').filter(Boolean);

  function done(state) {
    root.removeAttribute('data-pending');
    root.setAttribute('data-b2c-checked', state);
    updateCount();
  }
  function updateCount() {
    var el = root.querySelector('[data-b2c-types-count]');
    if (!el) return;
    var n = list.querySelectorAll(':scope > li').length;
    var tplStr = el.getAttribute(n === 1 ? 'data-one' : 'data-other') || '';
    if (tplStr) el.textContent = tplStr.replace('__N__', n);
  }

  var serverItems = Array.prototype.slice.call(list.querySelectorAll(':scope > li[data-b2c-cand]'));
  var tplItems = tpl ? Array.prototype.slice.call(tpl.content.children).filter(function (el) { return el.matches('li[data-b2c-cand]'); }) : [];
  var all = serverItems.concat(tplItems);
  if (!all.length) { done('none'); return; }

  var ids = [];
  all.forEach(function (li) { var id = li.getAttribute('data-pid'); if (id && ids.indexOf(id) < 0) ids.push(id); });

  function fail(reason) {
    // Veilig: niets uit het template tonen. Server-tegels blijven (normale modus); in strikte modus zijn er geen.
    done('failed:' + reason);
  }

  function apply(okIds) {
    // groepeer per type in rangvolgorde, met behoud van de bronvolgorde binnen een rang
    var types = [];
    var byType = {};
    all.forEach(function (li, i) {
      var t = li.getAttribute('data-type');
      if (!byType[t]) { byType[t] = []; types.push(t); }
      byType[t].push({ li: li, rank: parseInt(li.getAttribute('data-rank'), 10) || 2, i: i });
    });
    types.forEach(function (t) {
      var c = byType[t].slice().sort(function (a, b) { return a.rank - b.rank || a.i - b.i; });
      var winner = null;
      for (var k = 0; k < c.length; k++) {
        if (okIds[c[k].li.getAttribute('data-pid')]) { winner = c[k].li; break; }
      }
      var shown = serverItems.filter(function (li) { return li.getAttribute('data-type') === t && li.parentNode === list; });
      if (!winner) { shown.forEach(function (li) { li.remove(); }); return; }
      if (shown.indexOf(winner) >= 0) {
        shown.forEach(function (li) { if (li !== winner) li.remove(); });
        return;
      }
      var node = document.importNode(winner, true);
      if (shown.length) {
        list.replaceChild(node, shown[0]);
        shown.slice(1).forEach(function (li) { li.remove(); });
      } else {
        list.appendChild(node);
      }
    });
    done('ok');
  }

  if (sim === 'fail') { fail('sim'); return; }

  var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
  var body = JSON.stringify({ query: 'query B2CTypes($q:String!){products(first:50,query:$q){nodes{id availableForSale}}}', variables: { q: q } });
  var ctrl = window.AbortController ? new AbortController() : null;
  var timer = setTimeout(function () { if (ctrl) ctrl.abort(); fail('timeout'); timer = null; }, sim === 'slow' ? 1 : TIMEOUT_MS);
  fetch(window.location.origin + '/api/2026-10/graphql.json', {
    method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: body, signal: ctrl ? ctrl.signal : undefined
  }).then(function (r) { if (!r.ok) throw new Error('http-' + r.status); return r.json(); })
    .then(function (j) {
      if (!timer) return; // al teruggevallen
      clearTimeout(timer); timer = null;
      var nodes = j && j.data && j.data.products && j.data.products.nodes;
      if (!nodes || (j.errors && j.errors.length)) { fail('api'); return; }
      var ok = {};
      nodes.forEach(function (n) {
        var id = String(n.id).split('/').pop();
        if (n.availableForSale && simUnavail.indexOf(id) < 0) ok[id] = true;
      });
      apply(ok);
    })
    .catch(function (e) { if (timer) { clearTimeout(timer); timer = null; fail('error'); } });
  }
  run();
  // Variantwissel of sectie-herlading vervangt het blok: opnieuw controleren.
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { if (document.querySelector('[data-b2c-types]:not([data-b2c-checked])')) run(); }, 50);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
